export default [

    {
        question: "Программисты получают 100 тыс. рублей в месяц?",
        answer: "Да. В основном программисты получают 100-200 тыс. рублей, а хорошие специалисты и более.",
    },
    {
        question: "А много времени надо потратить, чтобы стать программистом?",
        answer: "Если вы чем-то увлечены время летит незаметно. 90% процентов программистов - самоучки. Чтобы чего-то достигнуть надо постараться.",
    },
    {
        question: "Что делают программисты?",
        answer: "Программист - это творческая профессия, как писатель или художник. Они разрабатывают приложения, сайты, игры и множество того, что на первый взгляд незаметно, но без чего современный мир невозможен.",
    },
    {
        question: "Нужно ли уметь пользоваться графическим планшетом, чтобы пойти на цифровую живопись?",
        answer: "Нет, вас всему научат.",
    },
    {
        question: "Зачем вы учите одновременно графике и программированию?",
        answer: "Любой сайт, приложение или игра состоит из внешнего вида и кода, мы хотим чтобы дети дизайнеры объединялись с программистами для создания чего-то интересного.",
    },
    {
        question: "Есть ли домашнее задание?",
        answer: "Обязательных домашних заданий нет, но мы подсказываем как можно расширить свои знания и навыки самостоятельно.",
    },

]